import CloseIcon from '@/components/ui/icons/close-icon';

export default function DrawerHeader({ toggleDrawer, t }) {
  return (
    <header className='flex items-center justify-between border-b border-[#e2e8f0] bg-[#f8fafc] px-4 py-3'>
      <h3 id='cartTitle' className='text-lg font-semibold'>
        {t('My Cart')}
      </h3>
      <button
        className='cursor-pointer border-0 bg-transparent text-xl text-[#64748b] hover:text-[#0f172a]'
        aria-label='إغلاق'
        onClick={toggleDrawer}
      >
        <CloseIcon className='size-[20px]' />
      </button>
    </header>
  );
}
